import {ChatCompletionUserMessageParam} from 'openai/resources';
import {OpenAIRole} from '../openAI.enums';

function openAIUserMessage(content: string): ChatCompletionUserMessageParam {
  return {
    role: OpenAIRole.User,
    content,
  };
}

export default openAIUserMessage;
